// pour les charts Piveteau
export const couleurs = {
  b3M3Yellow: "#FFB300",
  b3AboutageBlue: "#42A5F5",
  b3UsinageGreen: "#689F38",
  b3PanneauOrange: "#ff8000",
  b3M350percent: "#fafa6e",
  b3M380percent: "#aae479",
  b3M390percent: "#64c987",
  b3M3100percent: "#23aa8f",
  b3M3105percent: "#00898a",
  b3M3110percent: "#176877",
  b3M3120percent: "#2a4858",
  b3Aboutage50percent: "#fafa6e",
  b3Aboutage80percent: "#aae479",
  b3Aboutage90percent: "#64c987",
  b3Aboutage100percent: "#23aa8f",
  b3Aboutage105percent: "#00898a",
  b3Aboutage110percent: "#176877",
  b3Aboutage120percent: "#2a4858",
  b3Warning: "#FF0000",
  b3Edit1: "#AD1457",
  b3Edit2: "#F4511E",
  b3Edit3: "#009688",
  b3Edit4: "#D50000",
  b3Edit5: "#039BE5",
  b3Edit6: "#9E69AF",
  b3Edit7: "#A79B8E",
  b3Edit8: "#616161",
  b3Edit9: "#795548",
};
